
import axios from 'axios';
import { computed } from 'vue';
import {usePortalContentAndDesignStore} from "../../stores/partners/portalContentAndDesignStore";

export function useSubAccountLogin(turnstileTokenRef = null) {

    const portalContentAndDesignStore = usePortalContentAndDesignStore();

    const getFormActionRoute = computed(() => {
        return route('partners_int.sub-account-login.standard.login');
    });

    const turnstileEnabled = computed(() => portalContentAndDesignStore.turnstileSettings?.turnstile_enabled);

    const resetLoginErrors = () => {
        portalContentAndDesignStore.resetFormErrors('login');
    };

    const standardLogin = () => {
        resetLoginErrors();
        portalContentAndDesignStore.loggingInProgress = true;

        const payload = {
            email: portalContentAndDesignStore.loginFormData.email,
            password: portalContentAndDesignStore.loginFormData.password,
            ...portalContentAndDesignStore.getHoneypotPayload,
        };

        if (turnstileTokenRef?.value) {
            payload['cf-turnstile-response'] = turnstileTokenRef.value;
        }

        axios.post(getFormActionRoute.value, payload)
            .then(response => {
                if (+response.data.status === 1) {
                    resetLoginErrors();
                    window.location.href = response.data.redirect_url;
                } else {
                    portalContentAndDesignStore.loginFormErrors.responseError = response.data?.error;
                    portalContentAndDesignStore.loginFormData.password = '';
                    document.getElementById('password')?.focus();
                }
            }).catch(error => {
            if (error.response && error.response.status === 422) {
                portalContentAndDesignStore.loginFormErrors.validationErrors = error.response?.data?.errors;
            } else {
                console.log('Login error:', error.response);
                portalContentAndDesignStore.loginFormErrors.responseError = error.response?.data?.error || 'An error occurred. See console for details.';
            }

            })
            .finally(() => {
                portalContentAndDesignStore.loggingInProgress = false;
            });
        };

    const submitLogin = () => {
        if (portalContentAndDesignStore.isPreview) {
            return;
        }
        standardLogin();
    };

    return {
        submitLogin,
        standardLogin,
        turnstileEnabled,
    };
}

